import { useMemo } from 'react';

import { IFilterDefinition } from '@evinced-private/ui-common';

import { IFilterOptions } from 'src/common/helpers/DataFilterHelper';

export const useEffectiveFilters = (
	filters: IFilterOptions | undefined,
	filterDefinitions?: IFilterDefinition[]
): IFilterOptions => {
	return useMemo(() => {
		if (filters && Object.keys(filters).length > 0) {
			return filters;
		}

		if (!filterDefinitions) {
			return filters ?? {};
		}

		return filterDefinitions.reduce<IFilterOptions>((defaults, def) => {
			if (
				def.filterType === 'select' &&
				def.defaultValue &&
				Array.isArray(def.defaultValue) &&
				def.defaultValue.length > 0
			) {
				defaults[def.id] = def.defaultValue;
			}
			return defaults;
		}, {});
	}, [filters, filterDefinitions]);
};
